import { render, staticRenderFns } from "./OnboardingCompanyOpeningHoursForm.vue?vue&type=template&id=0452240e"
import script from "./OnboardingCompanyOpeningHoursForm.vue?vue&type=script&lang=js"
export * from "./OnboardingCompanyOpeningHoursForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports